import script from "./RibbonForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RibbonForm.vue?vue&type=script&setup=true&lang=js"

import "./RibbonForm.vue?vue&type=style&index=0&id=7a6985b5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6985b5"]])

export default __exports__